export default __webpack_public_path__ + "static/media/xwinbet365.4b90b9ce.svg";